import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { SvgIconComponent } from '../../atoms/svg-icon/svg-icon.component';
import { DataLayerType } from '../../../models/data-layer-type';

@Component({
  selector: 'app-poi-type-item',
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule, SvgIconComponent],
  templateUrl: './poi-type-item.component.html',
  styleUrl: './poi-type-item.component.scss',
})
export class PoiTypeItemComponent {
  @Input({ required: true }) poi!: DataLayerType;
  @Input() expanded = false;
  @Input() hasData = true;
  @Output() toggleExpanded = new EventEmitter<void>();
}
